import { ArrowDropDown } from "@material-ui/icons";
import { t } from "i18next";
import React, { memo, useState } from "react";
import PuiTypography from "../../../components/elements/PuiTypography";
import { TimelineInfo } from "../../models/Timeline";
import styles from "./TimelineTopHeader.module.css";

interface TimelineTopHeaderProps {
    timelineList: TimelineInfo[];
    timelineInfoList: TimelineInfo[];
    handleActionType: (type: string) => void;
    setIsOpenActionFilter: (action: boolean) => void;
    isOpenActionFilter: boolean;
    isOld: boolean;
    setIsOld: (old: boolean) => void;
    setTimelineList: (timlineList: TimelineInfo[]) => void;
}

function TimelineTopHeader({
    timelineList,
    timelineInfoList,
    handleActionType,
    setIsOpenActionFilter,
    isOpenActionFilter,
    isOld,
    setIsOld,
    setTimelineList,
}: TimelineTopHeaderProps) {
    // 更新日filter
    const [isOpenUpdateDateFilter, setIsOpenUpdateDateFilter] = useState<boolean>(false);
    const [filterDate, setFilterDate] = useState<string>(String(t("更新日")));

    // 更新日filter押下時
    const handleSortDate = (old: boolean, filter: string) => {
        if (timelineList.length > 0) {
            if (old) {
                setTimelineList(timelineList.reverse());
            } else if (isOld) {
                setTimelineList(timelineList.reverse());
            }
        }
        setIsOld(old);
        setFilterDate(filter);
        setIsOpenUpdateDateFilter(false);
    };

    return (
        <div className={styles.columnHeader}>
            <div className={styles.columnHeaderTitle}>
                <PuiTypography>{t("プロジェクト名")}</PuiTypography>
            </div>
            <div
                className={styles.updateDate}
                onClick={() => {
                    timelineList.length > 0 && setIsOpenUpdateDateFilter(!isOpenUpdateDateFilter);
                }}
                style={{ cursor: timelineList.length > 0 ? "pointer" : "auto" }}
            >
                <PuiTypography>{filterDate}</PuiTypography>
                <ArrowDropDown />
            </div>
            <div
                className={styles.upload}
                onClick={() => {
                    timelineInfoList &&
                        timelineInfoList.length > 0 &&
                        setIsOpenActionFilter(!isOpenActionFilter);
                }}
                style={{
                    cursor: timelineInfoList && timelineInfoList.length > 0 ? "pointer" : "auto",
                }}
            >
                <PuiTypography>{t("アクション")}</PuiTypography>
                <ArrowDropDown />
            </div>
            {/* 更新日押下時表示 */}
            {isOpenUpdateDateFilter && (
                <>
                    <div className={styles.updateDateFilter}>
                        <div onClick={() => handleSortDate(false, "新しい順")}>
                            <PuiTypography>{t("新しい順")}</PuiTypography>
                        </div>
                        <div onClick={() => handleSortDate(true, "古い順")}>
                            <PuiTypography>{t("古い順")}</PuiTypography>
                        </div>
                    </div>
                    <div
                        className={styles.filterBg}
                        onClick={() => setIsOpenUpdateDateFilter(false)}
                    ></div>
                </>
            )}
            {/* アクション押下時表示 */}
            {isOpenActionFilter && (
                <>
                    <div className={styles.actionFilter}>
                        <div onClick={() => handleActionType("")}>
                            <PuiTypography>{t("全て")}</PuiTypography>
                        </div>
                        <div onClick={() => handleActionType("CREATED")}>
                            <PuiTypography>{t("アップロード")}</PuiTypography>
                        </div>
                        <div onClick={() => handleActionType("CREATING")}>
                            <PuiTypography>{t("書き出し中")}</PuiTypography>
                        </div>
                        <div onClick={() => handleActionType("ERROR")}>
                            <PuiTypography>{t("書き出しエラー")}</PuiTypography>
                        </div>
                    </div>
                    <div
                        className={styles.filterBg}
                        onClick={() => setIsOpenActionFilter(false)}
                    ></div>
                </>
            )}
        </div>
    );
}
export default memo(TimelineTopHeader);
